import * as loadingsActions from './actions';
import * as loginActions from '../../login/actions';
import * as tablesActions from '../../tables/actions';
import * as branchesActions from '../../branches/actions';
import * as categoriesActions from '../../categories/actions';
import * as barsActions from '../../bars/actions';
import * as offersActions from '../../offers/actions';
import * as appActions from '../../app/actions';
import * as reportActions from '../../report/actions';
import * as reportReceiptActions from '../../report/receipt/actions';
import * as shiftsActions from '../../menu/report/shifts/actions';
import * as transactionActions from '../../menu/report/transaction/actions';
import * as barReportCashboxesActions from '../../menu/report/cashboxes/actions';
import * as creditActions from '../../creditBill/actions';
import * as menuHabituesListActions from '../../menu/credit/habitues/actions';
import * as menuDebtDetailActions from '../../menu/credit/debtDetail/actions';
import * as deviceActions from '../../device/actions';
import {Record} from 'immutable';

const State = Record({
    fullLoadingShow: false
});

const FULL_LOADING_SHOW = 'fullLoadingShow';

const loadingsReducer = (state = new State(), action) => {

    switch (action.type) {

        case deviceActions.SEND_LOCALESTORAGE_START:
        case tablesActions.FETCH_LAYOUTS_START:
        case barReportCashboxesActions.POST_BAR_REPORT_CASHBOX_VALUE_START:
        case barReportCashboxesActions.FETCH_BAR_REPORT_CASHBOXES_START:
        case menuDebtDetailActions.FETCH_PAY_DEBT_START:
        case menuDebtDetailActions.FETCH_HABITUE_BIlLS_TO_PAY_START:
        case menuDebtDetailActions.FETCH_HABITUE_DETAIL_START:
        case menuHabituesListActions.FETCH_MENU_HABITUES_START:
        case creditActions.DO_CREDIT_START:
        case creditActions.FETCH_HABITUE_LIST_START:
        case transactionActions.ADD_BAR_REPORT_TRANSACTION_START:
        case transactionActions.FETCH_BAR_REPORT_TRANSACTIONS_START:
        case transactionActions.DELETE_BAR_REPORT_TRANSACTION_START:
        case shiftsActions.BAR_REPORT_SHIFT_CHANGE_BARMAN_START:
        case shiftsActions.BAR_REPORT_SHIFT_CHANGE_VALUE_START:
        case shiftsActions.PAY_BAR_REPORT_SHIFT_START:
        case shiftsActions.FETCH_BAR_REPORT_SHIFT_BARMANS_START:
        case shiftsActions.FETCH_BAR_REPORT_SHIFTS_START:
        case shiftsActions.CLOSE_BAR_REPORT_SHIFT_START:
        case shiftsActions.ADD_BAR_REPORT_SHIFT_START:
        case shiftsActions.DELETE_BAR_REPORT_SHIFT_START:
        case reportReceiptActions.FETCH_BAR_REPORT_RECEIPTS_START:
        case reportActions.CLOSE_BAR_REPORT_START:
        case reportActions.FETCH_IS_BAR_REPORT_OPEN_START:
        case reportActions.FETCH_IS_BILL_OUT_OF_REPORT_START:
        case reportActions.FETCH_IS_BAR_REPORT_OPEN_2_START:
        case reportActions.OPEN_BAR_REPORT_START:
        case offersActions.CHOOSE_OFFER:
        case offersActions.FETCH_OFFERS_START:
        case barsActions.CHOOSE_BAR:
        case categoriesActions.FETCH_ONLY_CATEGORIES_START:
        case branchesActions.FETCH_BRANCHES_START:
        case loginActions.API_LOGIN_START:
        case loginActions.API_LOGIN_PIN_START:
        case loadingsActions.FULL_LOADING_SHOW: {
            return state.set(FULL_LOADING_SHOW, true);
        }

        case deviceActions.SEND_LOCALESTORAGE_SUCCESS:
        case deviceActions.SEND_LOCALESTORAGE_ERROR:
        case tablesActions.FETCH_LAYOUTS_SUCCESS:
        case tablesActions.FETCH_LAYOUTS_ERROR:
        case barReportCashboxesActions.POST_BAR_REPORT_CASHBOX_VALUE_ERROR:
        case barReportCashboxesActions.POST_BAR_REPORT_CASHBOX_VALUE_SUCCESS:
        case barReportCashboxesActions.FETCH_BAR_REPORT_CASHBOXES_SUCCESS:
        case barReportCashboxesActions.FETCH_BAR_REPORT_CASHBOXES_ERROR:
        case menuDebtDetailActions.FETCH_PAY_DEBT_SUCCESS:
        case menuDebtDetailActions.FETCH_PAY_DEBT_ERROR:
        case menuDebtDetailActions.FETCH_HABITUE_BIlLS_TO_PAY_SUCCESS:
        case menuDebtDetailActions.FETCH_HABITUE_BIlLS_TO_PAY_ERROR:
        case menuDebtDetailActions.FETCH_HABITUE_DETAIL_SUCCESS:
        case menuDebtDetailActions.FETCH_HABITUE_DETAIL_ERROR:
        case menuHabituesListActions.FETCH_MENU_HABITUES_SUCCESS:
        case menuHabituesListActions.FETCH_MENU_HABITUES_ERROR:
        case creditActions.DO_CREDIT_SUCCESS:
        case creditActions.DO_CREDIT_ERROR:
        case creditActions.FETCH_HABITUE_LIST_SUCCESS:
        case creditActions.FETCH_HABITUE_LIST_ERROR:
        case transactionActions.ADD_BAR_REPORT_TRANSACTION_SUCCESS:
        case transactionActions.ADD_BAR_REPORT_TRANSACTION_ERROR:
        case transactionActions.DELETE_BAR_REPORT_TRANSACTION_SUCCESS:
        case transactionActions.DELETE_BAR_REPORT_TRANSACTION_ERROR:
        case transactionActions.FETCH_BAR_REPORT_TRANSACTIONS_SUCCESS:
        case transactionActions.FETCH_BAR_REPORT_TRANSACTIONS_ERROR:
        case shiftsActions.BAR_REPORT_SHIFT_CHANGE_VALUE_ERROR:
        case shiftsActions.BAR_REPORT_SHIFT_CHANGE_VALUE_SUCCESS:
        case shiftsActions.PAY_BAR_REPORT_SHIFT_SUCCESS:
        case shiftsActions.PAY_BAR_REPORT_SHIFT_ERROR:
        case shiftsActions.BAR_REPORT_SHIFT_CHANGE_BARMAN_SUCCESS:
        case shiftsActions.BAR_REPORT_SHIFT_CHANGE_BARMAN_ERROR:
        case shiftsActions.FETCH_BAR_REPORT_SHIFT_BARMANS_SUCCESS:
        case shiftsActions.FETCH_BAR_REPORT_SHIFT_BARMANS_ERROR:
        case shiftsActions.CLOSE_BAR_REPORT_SHIFT_SUCCESS:
        case shiftsActions.CLOSE_BAR_REPORT_SHIFT_ERROR:
        case shiftsActions.DELETE_BAR_REPORT_SHIFT_SUCCESS:
        case shiftsActions.DELETE_BAR_REPORT_SHIFT_ERROR:
        case shiftsActions.ADD_BAR_REPORT_SHIFT_SUCCESS:
        case shiftsActions.ADD_BAR_REPORT_SHIFT_ERROR:
        case shiftsActions.FETCH_BAR_REPORT_SHIFTS_ERROR:
        case shiftsActions.FETCH_BAR_REPORT_SHIFTS_SUCCESS:
        case reportReceiptActions.FETCH_BAR_REPORT_RECEIPTS_ERROR:
        case reportReceiptActions.FETCH_BAR_REPORT_RECEIPTS_SUCCESS:
        case reportActions.CLOSE_BAR_REPORT_SUCCESS:
        case reportActions.CLOSE_BAR_REPORT_ERROR:
        case reportActions.OPEN_BAR_REPORT_ERROR:
        case reportActions.FETCH_IS_BAR_REPORT_OPEN_SUCCESS:
        case reportActions.FETCH_IS_BAR_REPORT_OPEN_ERROR:
        case reportActions.FETCH_IS_BILL_OUT_OF_REPORT_SUCCESS:
        case reportActions.FETCH_IS_BILL_OUT_OF_REPORT_ERROR:
        case appActions.SET_ERROR_OFFLINE:
        case offersActions.FETCH_OFFERS_SUCCESS:
        case offersActions.FETCH_OFFERS_ERROR:
        case categoriesActions.FETCH_INIT_APP_SUCCESS:
        case categoriesActions.FETCH_INIT_APP_ERROR:
        case categoriesActions.FETCH_ONLY_CATEGORIES_SUCCESS:
        case categoriesActions.FETCH_ONLY_CATEGORIES_ERROR:
        case branchesActions.FETCH_BRANCHES_SUCCESS:
        case branchesActions.FETCH_BRANCHES_ERROR:
        case loginActions.API_LOGIN_ERROR:
        case loginActions.API_LOGIN_PIN_ERROR:
        case loadingsActions.FULL_LOADING_HIDE: {
            return state.set(FULL_LOADING_SHOW, false);
        }
    }

    return state;
};

export default loadingsReducer;



// WEBPACK FOOTER //
// ./src/common/components/loadings/reducer.js